
import Vue from "vue";
import {ElectronCtep} from "@/utils/electron/electron-ctep";
import { BrowserInfo } from "@/utils/browser";
import { ISelectItem } from "winfakt-vue-components";
import AppSelectBankType from "@/components/bank/SelectBankType.vue";
import { CtepService } from "@/services/ctep-service";
import AppCtepTerminalSelect from "@/components/common/CtepTerminalSelect.vue";

export default Vue.extend({
	data(){
		let settings = CtepService.getSettings();
		return {
			settings,
			saving: false,
			serialPorts: [] as string[],
		};
	},
	computed: {
		hasModule():boolean {
			return CtepService.hasModule();
		},
		isElectron():boolean {
			return BrowserInfo.hasElectronConfigured();
		},
		isTcpMode():boolean {
			return this.settings.mode == "tcp";
		},
		isConnectMode():boolean {
			return this.settings.mode == "connect";
		},
		isSerialMode():boolean {
			return this.settings.mode == "serial";
		},
		isCloudMode():boolean {
			return this.settings.mode == "cloud";
		},
		serialPortItems():ISelectItem<string>[]{
			return this.serialPorts.map(s=>{
				return {
					text: s,
					value: s
				};
			});
		},
		disabled():boolean{
			return this.settings.mode == "off";
		},
		serialPortSelectDisabled():boolean {
			if (this.disabled) return true;
			if (!this.isSerialMode) return true;
			return false;
		},
		tcpPortDisabled():boolean {
			if (this.disabled) return true;
			if (!this.isTcpMode) return true;
			return false;
		},
		connectUrlDisabled():boolean {
			if (this.disabled) return true;
			if (!this.isConnectMode) return true;
			return false;
		},
		showSelfCertificationButton():boolean{
			return process.env.NODE_ENV == "development";
		},
	},
	methods: {
		setSerialMode(){
			this.settings.mode = "serial";
			if (this.serialPorts.length > 0) {
				this.settings.comPort = this.serialPorts[0];
			}
		},
		setTcpMode(){
			this.settings.mode = "tcp";
			this.settings.port = 9000;
		},
		setConnectMode(){
			this.settings.mode = "connect";
			this.settings.connectUrl = "http://localhost:1234";
		},
		setCloudMode(){
			this.settings.mode = "cloud";
		},
		setModeDisabled(){
			this.settings.mode = "off";
		},
		async save(){
			if (this.saving) return;
			this.saving = true;
			try{
				CtepService.setSettings(this.settings);
				await ElectronCtep.reinit();
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
			}catch(err){

			}
			this.saving = false;
		},
	},
	async created(){
		if (!this.isElectron) return;
		this.serialPorts = await ElectronCtep.listSerialPorts();
	},
	components: {
		AppSelectBankType,
		AppCtepTerminalSelect
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
